import { Preference } from './preference.model';

export class TablePreference {

    public tableId: string;

    public favouriteConfig: Preference;
    public columnConfig: Preference;
    public columGroupConfig: Preference;
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/models/table-preference.model.ts